export const enumBackgroundTheme = {
    WHISPER : "whisper"
}